import { num } from "@/lib/format";

const n2 = (v) => num(Math.round((v || 0) * 100) / 100);

const Status = ({ r }) => {
  if (r.fused) return r.to_fuse ? <span className="font-semibold text-sky-400">Da adesivare {n2(r.to_fuse)} m</span> : <span className="text-emerald-400">Già adesivato</span>;
  if (!r.missing_now) return <span className="text-emerald-400">Disponibile</span>;
  if (!r.to_order) return <span className="text-amber-400">Basta con quello in arrivo</span>;
  return <span className="font-semibold text-rose-400">Da ordinare {n2(r.to_order)} {r.unit}</span>;
};

const Table = ({ title, rows, label, testid }) => (
  <div>
    <h4 className="mb-2 font-display text-sm font-semibold">{title}</h4>
    <div className="overflow-x-auto rounded-md border border-border">
      <table className="w-full text-sm" data-testid={testid}>
        <thead><tr className="border-b border-border text-xs text-muted-foreground">
          <th className="p-2 text-left font-medium">Materiale</th><th className="p-2 text-right font-medium">Serve</th><th className="p-2 text-right font-medium" title="Giacenza meno quello che useranno i lotti già programmati o in taglio">Disponibile</th>
          <th className="p-2 text-right font-medium" title="Già destinato ai lotti programmati (tessuto e accessori) o in taglio (accessori), non ancora scalato">Impegnato</th>
          <th className="p-2 text-right font-medium">In arrivo</th><th className="p-2 text-right font-medium">Stato</th>
        </tr></thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="border-b border-border/50 last:border-0" data-testid={`${testid}-row-${i}`}>
              <td className="p-2">{label(r)}</td><td className="p-2 text-right font-semibold">{n2(r.needed)} {r.unit}{!r.fused && r.to_fuse > 0 && <span className="block text-[10px] font-normal text-sky-400">di cui {n2(r.to_fuse)} da adesivare</span>}</td>
              <td className={`p-2 text-right ${r.stock < 0 ? "text-rose-400" : ""}`}>{n2(r.stock)}</td><td className="p-2 text-right text-muted-foreground" data-testid={`${testid}-row-${i}-reserved`}>{r.reserved ? n2(r.reserved) : "-"}</td><td className="p-2 text-right">{n2(r.arriving)}</td><td className="p-2 text-right text-xs"><Status r={r} /></td>
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={6} className="p-3 text-xs text-muted-foreground">Nessun consumo indicato.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>
);

const Producible = ({ rows }) => !rows?.length ? null : (
  <div data-testid="check-producible">
    <h4 className="mb-2 font-display text-sm font-semibold">Quanti capi puoi fare con il magazzino attuale</h4>
    <div className="flex flex-wrap gap-2">
      {rows.map((r, i) => (
        <span key={i} className="rounded-md border border-border px-3 py-1.5 text-xs" data-testid={`check-producible-${i}`}>
          {r.code ? `${r.code.toUpperCase()} ` : ""}<b>{r.color}</b>: <b className={r.producible ? "text-emerald-400" : "text-rose-400"}>{num(r.producible)}</b> capi{r.limiting ? <span className="text-muted-foreground"> · limita {r.limiting}</span> : null}
        </span>
      ))}
    </div>
  </div>
);

export const MaterialsCheck = ({ res }) => (
  <div className="space-y-4">
    {res?.missing?.length > 0 && (
      <div className="rounded-md border border-amber-400/40 bg-amber-400/10 px-3 py-2 text-xs text-amber-400" data-testid="check-missing">
        <p className="font-semibold">Materiali non presenti in magazzino (conteggiati come da ordinare):</p>
        {[...new Set(res.missing)].map((m) => <p key={m}>{m}</p>)}
      </div>
    )}
    <Producible rows={res?.producible} />
    <Table title="Tessuti (per tipo e colore)" rows={res?.fabrics || []} label={(r) => `${r.material && r.material.toLowerCase() !== (r.fabric_type || "").toLowerCase() ? `${r.fabric_type} ${r.material}` : r.fabric_type} · ${r.color || "senza colore"}${r.fused ? " (adesivato)" : ""}`} testid="check-fabrics" />
    <Table title="Accessori" rows={res?.accessories || []} label={(r) => `${r.name}${r.color ? ` · ${r.color}` : ""}`} testid="check-accessories" />
  </div>
);
